const FAQSIcon = (props) => {
  return (
    <span className="anticon ant-menu-item-icon">
      <img src="/assets/images/FAQ.svg" alt="Disease" width="24" height="24" />
    </span>
  );
};

export default FAQSIcon;
